<script setup lang="ts">
import RichTextEditor from "@/components/ui/RichTextEditor.vue";
import { useTemplateRef } from "vue";
import MarkdownWidget from "./MarkdownWidget.vue";

const { editable } = defineProps<{ editable: boolean }>();

const richTextEditor = useTemplateRef<InstanceType<typeof RichTextEditor>>("richTextEditor");
const value = defineModel<string>("value", { default: "" });
</script>

<template>
  <div class="editor-wrapper">
    <Transition name="fade" mode="out-in">
      <div v-if="editable" class="editor">
        <div class="format-actions">
          <div class="format" @click="richTextEditor?.markBold()">
            <i class="icon icon-bold" />
          </div>
          <div class="format" @click="richTextEditor?.markItalic()">
            <i class="icon icon-italic" />
          </div>
          <div class="format" @click="richTextEditor?.markList()">
            <i class="icon icon-list" />
          </div>
        </div>
        <RichTextEditor ref="richTextEditor" v-model:value="value" :focus="true" />
      </div>
      <div v-else class="preview">
        <MarkdownWidget :source="value" />
      </div>
    </Transition>
  </div>
</template>

<style scoped>
.editor-wrapper {
  .editor {
    .format-actions {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
    }
  }
}
</style>
